import currentRouteParamsRecordId from 'root/src/client/logic/route/selectors/currentRouteParamsRecordId'

import { apiStoreLenses } from 'root/src/client/logic/api/lenses'

const { viewPayoutMethodChild } = apiStoreLenses

export default (state) => {
	const paramsRecordId = currentRouteParamsRecordId(state)
	return viewPayoutMethodChild(paramsRecordId, state)
}
